import React from 'react';
// styles
import styles from './BankStatement.mod.css';
import { SUBSCRIPTION_PRICE } from '../Billing';

const BankStatement = () => (
  <div className={styles.container}>
    <p className={styles.description}>
      You purchase will say "LADDR" on your bank statement
      <br />
      And will look like this:
    </p>
    <div className={styles.tableWrapper}>
      <div className={styles.table}>
        <div className={styles.tableHeader}>
          <p>EARTHBANK **** 1234 STATEMENT</p>
        </div>
        <div className={styles.contentHeading}>
          <p>Amount</p>
          <p>Transaction</p>
        </div>
        <div className={styles.content}>
          <p>${SUBSCRIPTION_PRICE}.00</p>
          <div className={styles.transaction}>
            <p className={styles.transactionTitle}>LADDR</p>
            <p className={styles.transactionDescription}>PAYROLL</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default BankStatement;



// WEBPACK FOOTER //
// ./src/containers/Billing/components/BankStatement.jsx